import { NavBar } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { AppSubNav } from "../AppSubNav";

const NavigationDocuments = () => {
  return (
    <AppSubNav>
      <NavBar.Item
        href={{ pathname: "/documents" }}
      >{t`Documents`}</NavBar.Item>
    </AppSubNav>
  );
};

export default observer(NavigationDocuments);
